import React from 'react'
import { doc, updateDoc } from 'firebase/firestore'

import { db } from '../../firebase'
import { useForm, useError } from '../../hooks'
import TextField from '../Form/TextField'
import Button from '../Button'
import ContextMenu from '../ContextMenu'
import LocationForm, { parseLocation } from '../LocationForm'

export default function ({ site, onFinishEditing }) {
  const setError = useError()
  const [getFieldProps, formData, formError] = useForm()

  async function handleSubmit(e) {
    e.preventDefault()

    const { name } = formData
    let location

    try {
      location = parseLocation(formData, site.locations[0]) 
    } catch (err) {
      if (err.message === 'invalid_format') {
        formError({
          format: 'Invalid location format.'
        })
      } else {
        setError(err)
      }
      return
    }

    try {
      await updateDoc(doc(db, 'sites', site.id), {
        name,
        locations: [location]
      })
      onFinishEditing()
    } catch (err) {
      if (err.message === 'validation_error') {
        formError(err.props)
      } else {
        setError(err)
      }
    }
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <TextField
          label='Name'
          name='name'
          defaultValue={site.name}
          required={true}
          {...getFieldProps()}
        />
        <LocationForm
          getFieldProps={getFieldProps}
          formData={formData}
          defaultValue={site.locations[0]}
        />
        <br />
        <div className='flex justify-end'>
          <Button type='submit'>Update</Button>
        </div>
      </form>
    </div>
  )
}
